import { moments } from '../../../mocks/guaData';

const art = [
  'https://readdy.ai/api/search-image?query=Stylized%20editorial%20flat%20illustration%20of%20a%20tv%20variety%20studio%20spotlight%20with%20two%20contrasting%20silhouette%20figures%2C%20one%20calm%20host%20in%20suit%20and%20one%20wild%20dancing%20figure%2C%20split%20composition%20warm%20coral%20and%20amber%20color%20palette%2C%20minimal%20geometric%20shapes%2C%20subtle%20grain%20texture%2C%20modern%20web%20illustration%2C%20clean%20background&width=800&height=500&seq=moment-gossip-01&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Stylized%20editorial%20flat%20illustration%20of%20a%20smartphone%20live%20streaming%20scene%20with%20camera%20and%20ring%20light%2C%20a%20split%20before%20after%20face%20reveal%20concept%20with%20one%20smooth%20and%20one%20messy%20side%2C%20warm%20coral%20and%20peach%20color%20palette%2C%20modern%20minimal%20geometric%20web%20illustration%2C%20soft%20grain%20texture%2C%20clean%20light%20background&width=800&height=500&seq=moment-live-02&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Stylized%20editorial%20flat%20illustration%20of%20two%20masks%20floating%20over%20a%20shocked%20person%2C%20representing%20fake%20persona%20versus%20real%20self%2C%20contrast%20concept%2C%20warm%20amber%20and%20coral%20palette%20with%20sage%20green%20accent%2C%20minimal%20geometric%20shapes%2C%20subtle%20grain%2C%20modern%20web%20illustration%2C%20clean%20background&width=800&height=500&seq=moment-persona-03&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Stylized%20editorial%20flat%20illustration%20of%20an%20influencer%20holding%20camera%20next%20to%20a%20big%20luxury%20mansion%20drawing%20that%20peels%20away%20like%20paper%20to%20reveal%20a%20small%20simple%20room%20behind%2C%20contrast%20wealth%20versus%20reality%20concept%2C%20warm%20coral%20amber%20palette%2C%20minimal%20geometric%20web%20illustration%2C%20subtle%20grain%20texture%2C%20clean%20light%20background&width=800&height=500&seq=moment-wealth-04&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Stylized%20editorial%20flat%20illustration%20of%20a%20lecturer%20at%20podium%20with%20blank%20speech%20bubble%20above%20head%20and%20confused%20small%20audience%2C%20awkward%20silent%20pause%20concept%2C%20warm%20coral%20and%20amber%20color%20palette%20with%20sage%20accent%2C%20minimal%20geometric%20shapes%2C%20modern%20web%20illustration%2C%20subtle%20grain%2C%20clean%20background&width=800&height=500&seq=moment-guru-05&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Stylized%20editorial%20flat%20illustration%20of%20a%20polite%20bowing%20idol%20on%20stage%20in%20spotlight%20on%20one%20side%20and%20an%20arrogant%20frowning%20same%20figure%20standing%20near%20backstage%20assistants%20on%20the%20other%20side%2C%20duality%20contrast%20concept%2C%20warm%20coral%20amber%20palette%2C%20minimal%20geometric%20modern%20web%20illustration%2C%20subtle%20grain%20texture%2C%20clean%20background&width=800&height=500&seq=moment-idol-06&orientation=landscape',
];

const chipStyle = ['bg-primary-100 text-primary-700', 'bg-accent-100 text-accent-800', 'bg-secondary-100 text-secondary-800'];

export default function MomentShowcase() {
  return (
    <section id="moments" className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
      <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
        <div>
          <p className="text-xs font-bold uppercase tracking-widest text-accent-600">Classic Moments</p>
          <h3 className="mt-2 flex items-center gap-2 text-2xl font-black text-foreground-950 md:text-3xl">
            <i className="ri-flashlight-fill text-accent-500" aria-hidden="true"></i>
            反差名场面精选
          </h3>
          <p className="mt-2 text-sm text-foreground-600">本周最出圈的台前幕后对比，逐帧为你复盘</p>
        </div>
        <a
          href="#feeds"
          className="inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-background-200 px-5 py-2 text-sm font-semibold text-foreground-800 transition hover:bg-primary-500 hover:text-background-50"
        >
          查看更多名场面
          <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </a>
      </div>

      <div className="mt-8 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {moments.map((m, i) => (
          <article
            key={m.title}
            className="group overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition hover:-translate-y-1 hover:shadow-soft"
          >
            <div className="relative aspect-[8/5] overflow-hidden">
              <img
                src={art[i]}
                alt={`反差吃瓜名场面 · ${m.title}`}
                className="h-full w-full object-cover transition duration-500 group-hover:scale-105"
              />
              <span
                className={`absolute left-3 top-3 rounded-full px-3 py-1 text-xs font-bold ${chipStyle[i % chipStyle.length]}`}
              >
                {m.cate}
              </span>
              <span className="absolute bottom-3 right-3 rounded-full bg-foreground-950/60 px-2.5 py-1 text-xs font-medium text-background-50 backdrop-blur">
                <i className="ri-eye-line mr-1" aria-hidden="true"></i>
                {m.views}
              </span>
            </div>
            <div className="p-5">
              <h4 className="line-clamp-2 font-bold leading-snug text-foreground-950 group-hover:text-primary-700">
                {m.title}
              </h4>
              <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{m.brief}</p>
              <div className="mt-4 flex items-center justify-between text-xs text-foreground-400">
                <span>
                  <i className="ri-time-line mr-1" aria-hidden="true"></i>
                  {m.time} 更新
                </span>
                <span className="inline-flex items-center gap-1 font-semibold text-accent-600">
                  复盘这段
                  <i className="ri-arrow-right-up-line" aria-hidden="true"></i>
                </span>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}